import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Copyright } from 'lucide-react';
import { useTranslation } from '../contexts/TranslationContext';
import { isNativeApp } from '../utils/platform';

const Footer = () => {
  const { t } = useTranslation();

  if (isNativeApp()) return null;

  return (
    <footer className="gadkot-footer font-marathi">
      <div className="gadkot-footer__top-bar" aria-hidden="true" />
      <div className="container mx-auto px-4 sm:px-6 gadkot-footer__inner">
        <div className="gadkot-footer__grid">
          {/* Brand */}
          <div className="gadkot-footer__col">
            <h4 className="gadkot-footer__heading font-marathi-display">
              <Link to="/" className="gadkot-footer__heading-link">
                {t('footer.title')}
              </Link>
            </h4>
            <div className="gadkot-footer__body">
              <p className="gadkot-footer__desc">{t('footer.description')}</p>
              <div className="gadkot-footer__copyright">
                <Copyright className="h-4 w-4 shrink-0" aria-hidden="true" />
                <span>{t('footer.rights')}</span>
              </div>
            </div>
          </div>

          {/* Contact */}
          <div className="gadkot-footer__col">
            <h4 className="gadkot-footer__heading font-marathi-display">{t('footer.contact')}</h4>
            <ul className="gadkot-footer__list">
              <li className="gadkot-footer__item">
                <MapPin className="gadkot-footer__icon" aria-hidden="true" />
                <span>{t('footer.location')}</span>
              </li>
              <li className="gadkot-footer__item">
                <Mail className="gadkot-footer__icon" aria-hidden="true" />
                <a href="mailto:info@gadkot.com" className="gadkot-footer__link">
                  info@gadkot.com
                </a>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div className="gadkot-footer__col">
            <h4 className="gadkot-footer__heading font-marathi-display">{t('footer.followUs')}</h4>
            <div className="gadkot-footer__body">
              <span className="gadkot-footer__handle">@gadkot</span>
              <p className="gadkot-footer__tagline">{t('footer.socialTagline')}</p>
            </div>
          </div>
        </div>

        <div className="gadkot-footer__bottom">
          <p className="gadkot-footer__bottom-text">
            {t('footer.allRightsReserved')}
            <span className="gadkot-footer__bottom-dot" aria-hidden="true">•</span>
            {t('footer.privacyPolicy')}
            <span className="gadkot-footer__bottom-dot" aria-hidden="true">•</span>
            {t('footer.termsOfService')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
